import { useLocation } from "react-router-dom";
import BreadcrumbCom from "../BreadcrumbCom";
import { ManufacturerTypeId } from "../../utils";

export default function PageTitle({ title, showLoginText, breadcrumb = [] }) {
  const { state } = useLocation();

  return (
    <div className="page-title-wrapper bg-[#FFFAEF] w-full h-[173px] py-10">
      <div className="container-x mx-auto">
        <div className="mb-5">
          <BreadcrumbCom paths={breadcrumb} />
        </div>
        <div className="text-center">
          <h1 className="text-3xl font-semibold text-qblack">{title}</h1>
          {showLoginText &&
            <div className="signup-area flex justify-center mt-2">
              <p className="text-2x1 text-qgraytwo font-normal">
                Already have an Account?
                {state?.userType == ManufacturerTypeId ? (
                  <a href={process.env.REACT_APP_SELLER_PORTAL_URL} target="blank" className="ml-1 text-qblack">
                    Log In
                  </a>
                ) : (
                  <a href="/login" className="ml-1 text-qblack">
                    Log In
                  </a>
                )}
              </p>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
